import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/link_arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-75bdedf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "heading-container tablet:my-lg"
}
const _hoisted_2 = { class: "inline" }
const _hoisted_3 = { class: "mb-lg" }
const _hoisted_4 = { class: "link-button text-xl text-black underline font-bold transition-colors duration-300 group-hover:text-primary" }
const _hoisted_5 = { class: "mr-md" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "inline opacity-0 transition-opacity duration-300 group-hover:opacity-100",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: _normalizeClass(["link group", [_ctx.__elementspacingclass]]),
    to: _ctx.link.replace(/^https:\/\/wpdev.netconnect.ch/, '')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Card, { class: "container bg-background relative p-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["img-element w-full bg-contain bg-no-repeat bg-center", [_ctx.__elementsizeclass]]),
            style: _normalizeStyle({
          'background-image': `url(${_ctx.imageurl})`
        })
          }, null, 6),
          (_ctx.heading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.heading), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.linklabel), 1),
            _hoisted_6
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class", "to"]))
}